module.exports = "<span class=\"snackbar-opt\">\r\n    Ocorreu algum erro!\r\n</span>"